// source: design/src/pages/AIPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_zh';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-ai.jpg',
  heroTitle: 'AI',
  pageTitle: 'AI',
  heroSubtitle: 'Artificial Intelligence',
  heroTagline: '将AI技术深度融入企业运营，释放数据价值，驱动智能决策',
  intro: [
    '人工智能正在重塑企业的运营方式。从趋势预测到视觉智能检测，从智能客服到供应链优化，AI技术为企业带来了前所未有的效率提升与成本优化空间。',
    '飞狼将前沿AI技术与企业业务场景深度融合，为客户提供从AI战略规划、数据治理、模型开发到系统集成的全链路服务，助力企业实现智能化转型。',
  ],
  capTitle: '核心能力',
  capSubtitle: 'Core Capabilities',
  capabilities: [
    {
      icon: 'si/si-icons/trending-up.svg',
      title: '趋势预测',
      desc: '基于设备传感器数据、历史业务数据与机器学习算法，预测设备故障概率与供应链需求趋势，提前安排维护与补货，降低非计划停机30%-50%，需求预测准确率提升至85%以上。',
    },
    {
      icon: 'si/si-icons/eye.svg',
      title: '视觉智能检测',
      desc: '利用深度学习实现产品外观缺陷自动检测，检测精度达95%以上，速度比人工快10倍。',
    },
    {
      icon: 'si/si-icons/message-square.svg',
      title: '自然语言处理',
      desc: '智能客服机器人、合同自动审核、舆情监控，7×24小时自动化处理。',
    },
    {
      icon: 'si/si-icons/sparkles.svg',
      title: '生成式AI应用',
      desc: '基于大语言模型的智能助手、知识管理、内容生成，提升员工生产力30%以上。',
    },
    {
      icon: 'si/si-icons/database.svg',
      title: 'AI数据平台',
      desc: '企业级数据湖与MLOps平台，支撑AI模型全生命周期管理。',
    },
    {
      icon: 'si/si-icons/globe.svg',
      title: 'GEO',
      titleExtra: '（Generative Engine Optimization）',
      desc: '生成式引擎优化，面向AI搜索的内容优化（区别于传统 SEO）。',
    },
  ],
  industries: [
    {
      icon: 'si/si-icons/factory.svg',
      title: '制造业',
      cases: [
        '设备预测性维护与故障诊断',
        '产品质量视觉检测',
        '生产排程智能优化',
      ],
    },
    {
      icon: 'si/si-icons/shopping-cart.svg',
      title: '零售业',
      cases: [
        '智能需求预测与补货',
        '客户行为分析与精准营销',
        '智能客服与售后支持',
      ],
    },
    {
      icon: 'si/si-icons/heart-pulse.svg',
      title: '医疗健康',
      cases: [
        '医学影像辅助诊断',
        '药物研发数据分析',
        '智能健康管理',
      ],
    },
    {
      icon: 'si/si-icons/landmark.svg',
      title: '金融服务',
      cases: [
        '智能风控与反欺诈',
        '自动化报告生成',
        '客户画像与精准推荐',
      ],
    },
  ],
  methodTitle: 'AI落地五步法',
  methodTitleEn: 'Five-Step Method for AI Implementation',
  methodologySteps: [
    {
      num: '1',
      title: '业务诊断',
      desc: '识别高价值AI应用场景',
    },
    {
      num: '2',
      title: '数据准备',
      desc: '数据采集、清洗与治理',
    },
    {
      num: '3',
      title: '模型开发',
      desc: '算法选型、训练与优化',
    },
    {
      num: '4',
      title: '系统集成',
      desc: '与现有业务系统对接',
    },
    {
      num: '5',
      title: '持续运营',
      desc: '模型监控、迭代与优化',
    },
  ],
  benefits: [
    {
      number: '30%+',
      title: '运营效率提升',
      desc: '自动化替代重复性工作，释放人力聚焦高价值任务',
    },
    {
      number: '25%',
      title: '决策准确率提升',
      desc: '数据驱动决策替代经验判断，降低人为偏差',
    },
    {
      number: '15-20%',
      title: '运营成本降低',
      desc: '预测性维护、智能排产、自动化质检降低综合成本',
    },
    {
      number: '100%',
      title: '客户满意度提升',
      desc: '智能客服24小时响应，个性化推荐提升体验',
    },
  ],
};
